import { TaskAdd02Icon } from "@hugeicons-pro/core-stroke-rounded";
import { HugeiconsIcon } from "@hugeicons/react";
import { FC } from "react";
import { Link } from "react-router-dom";

interface BuildSurveyCardProps {
  to: string;
}

export const BuildSurveyCard: FC<BuildSurveyCardProps> = ({ to }) => {
  return (
    <Link
      to={to}
      className="animate-appear flex h-[116px] w-full cursor-pointer flex-col items-center justify-center rounded-lg border border-dashed border-primary-500 bg-primary-20 transition-all hover:bg-primary-50 gap-2"
    >
      <HugeiconsIcon
        icon={TaskAdd02Icon}
        className="text-primary-500 shrink-0"
        size={24}
      />
      <p className="text-base font-bold text-primary-600">Build survey</p>
    </Link>
  );
};
